import { PermissionDto } from './PermissionDto';

export class RoleDto {
  id: number;
  name: string;
  description: string;
  applicationId: string;
  permissions: Array<PermissionDto>;
}
